// import React from 'react'
// import { TypeAnimation } from 'react-type-animation';
// import ScrollyVideo from 'scrolly-video/dist/ScrollyVideo.cjs.jsx';
// import logo from "../assets/images/gold.png"

// function ScrollVideo() {
//   return (

//     <div  className='hidden lg:block'>
//       <div className={'scrolly-container relative'} style={{ height: '1000vh' }}>
//         <ScrollyVideo src="/videos/output.mp4" full={true} transitionSpeed={14} />
//         <div className='absolute top-[500px] left-72'>
//           <h1 className='text-gold text-7xl'>Kod Değil Değer Üretiyoruz</h1>
//         </div>
//       </div>

//     </div>

//   )
// }

// export default ScrollVideo
import { useRef, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import './video.css';
import bannerimage from "../assets/images/bannerimage.jpg"

const ScrollVideo = ({

  CoverElement,
  belowNav = false,
}) => {
  const src = "/videos/banner.mp4"
  const srcMobil = "/videos/bannerMobil.mp4"
  const heightPerSecond = 200
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState("100vh");
  const [videoEnded, setVideoEnded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [videoLoading, setVideoLoading] = useState(true)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //deneme

  const onVideoEnd = () => {
    setVideoEnded(true);
  };

  useEffect(() => {
    let lastScroll = window.scrollY;

    const handleScroll = () => {
      if (!videoRef.current || !containerRef.current) return;

      const containerTop = containerRef.current.offsetTop;
      const containerHeight = containerRef.current.offsetHeight;
      const containerBottom = containerTop + containerHeight;

      const scrollPos = window.scrollY;
      const viewportBottom = scrollPos + window.innerHeight;

      const isVideoInView =
        containerTop < viewportBottom && containerBottom > scrollPos;

      if (isVideoInView && !videoRef.current.paused) {
        videoRef.current.pause();
      }

      const percentageScrolled = (scrollPos - containerTop) / containerHeight;
      if (
        Number.isFinite(percentageScrolled) &&
        videoRef.current.duration
      ) {
        const targetTime = percentageScrolled * videoRef.current.duration;

        if (
          (videoRef.current.currentTime < targetTime &&
            scrollPos > lastScroll) ||
          (videoRef.current.currentTime > targetTime &&
            scrollPos < lastScroll)
        ) {
          videoRef.current.currentTime = targetTime;
          setVideoEnded(false);
        }
      }

      lastScroll = scrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleVideoLoaded = () => {
    if (videoRef.current) {
      setContainerHeight(
        `${videoRef.current.duration * heightPerSecond}px`
      );
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      if (videoElement.readyState >= 1) {
        handleVideoLoaded();
      } else {
        videoElement.addEventListener("loadedmetadata", handleVideoLoaded);
      }

      return () => {
        videoElement.removeEventListener("loadedmetadata", handleVideoLoaded);
      };
    }
  }, []);
  const { t, i18n } = useTranslation();

  return (
    <div
      ref={containerRef}
      style={{
        height: windowWidth > 750 ? containerHeight : "60vh",
        width: "100%",
        position: "relative",
      }}
    >
      {!videoLoading ? <img
        src={bannerimage}
        alt="banner_image"
        style={{
          position: "absolute",
          // top: "70px",
          left: 0,
          width: "100%",
          height: windowWidth > 750 ? "100vh" : "60vh",
          objectFit: "cover",
          zIndex: 1,
        }}
      /> : null}
      <video
        muted
        playsInline
        controls={false}
        autoPlay
        // ref={videoRef}
        onEnded={onVideoEnd}
        onLoadedData={() => setVideoLoading(true)}
        className={windowWidth > 750 ? "h-screen" : "h-[60vh]"}
        style={{
          position: "sticky",
          top: belowNav ? "68px" : "0",
          width: "100%",
          objectFit: "cover",
          marginTop: '70px',

        }}
      >
        <source src={windowWidth > 600 ? src : srcMobil} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div>
        <h1 className="fade-in-out text-[#dcbc5c] relative -mt-64 md:-mt-96 font-aventa text-center text-xl sm:text-3xl md:text-4xl ml-4 md:ml-16">
          {t('slogan')}
        </h1>

      </div>


      {CoverElement && CoverElement}
    </div>
  );
};

export default ScrollVideo;
